import { createFileRoute } from '@tanstack/react-router';

import { ConnectOfferSetupComplete } from 'src/apps/checkout/app/pages/ConnectOffer.SetupComplete';

export const Route = createFileRoute(
  '/_auth/_only-header/store/connect-offer/setup-complete'
)({
  component: () => <ConnectOfferSetupComplete />,
});
